export default "__VITE_ASSET__Df_2bL$k__"